import { render, staticRenderFns } from "./ImportadorCotizacionesModal.vue?vue&type=template&id=788d87c0"
import script from "./ImportadorCotizacionesModal.vue?vue&type=script&lang=js"
export * from "./ImportadorCotizacionesModal.vue?vue&type=script&lang=js"
import style0 from "./ImportadorCotizacionesModal.vue?vue&type=style&index=0&id=788d87c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports